/*
 * @Author: Xu Chen
 * @Date: 2019-05-08 16:00:14
 * @Last Modified by: gujt
 * @Last Modified time: 2022-02-21 11:25:28
 * @description: 教师查看考勤看板
 */

import api from '@/api/teacher';
import util from '@/libs/util.js';
import { getTimeRangeNow } from '@/utils/index.js';

const teacher = {
  namespaced: true,
  state: {
    /* 时间筛选 today-今天 yesterday-昨天 week-本周 month-本月 */
    timeTab: 'today',
    /* 班级列表 */
    classList: [],
    /* 当前选中的班级 classId<!!!>teacherId */
    selectedClass: '',
    selClass: '',
    /* 作息策略列表 */
    strategyListByTeacher: [],
    /* 当前选中的作息策略 id<!!!>name<!!!>sectionId */
    selectedStrategy: '',
    /* 考勤统计饼状图数据 */
    chartDataForPie: [],
    /* [周六, 周日] 选中true 不选中false */
    ifCheckSatAndSun: [false, false],
    /* 按时间段统计的柱状图 */
    chartDataByTimeForBar: [],
    /* 迟到学生列表 */
    laterList: [],
    /* 为签到学生列表 */
    absenterList: [],
    /* 按日期统计的折线图 */
    chartDataByDateForLine: [],
    /* 获取考勤数据loading */
    getAttendanceDataIsLoading: false,
    /* 学校列表 */
    schoolList: [],
    /* 当前选中的学校 */
    selectedSchool: undefined,
    // clockType :0-自动点名，1-班牌
    clockType: '1'
  },

  mutations: {
    SET_TIME_TAB: (state, timeTab) => {
      state.timeTab = timeTab;
    },
    SET_CLASS_LIST: (state, classList) => {
      state.classList = classList;
    },
    SET_SELECTED_CLASS: (state, selectedClass) => {
      state.selectedClass = selectedClass;
    },
    SET_SEL_CLASS: (state, selectedClass) => {
      state.selClass = selectedClass;
    },
    SET_STRATEGY_LIST_BY_TEACHER: (state, strategyListByTeacher) => {
      state.strategyListByTeacher = strategyListByTeacher;
    },
    SET_SELECTED_STRATEGY: (state, selectedStrategy) => {
      state.selectedStrategy = selectedStrategy;
    },
    SET_CHART_DATA_FOR_PIE: (state, chartDataForPie) => {
      state.chartDataForPie = chartDataForPie;
    },
    SET_CHECK_SAT_AND_SUN: (state, ifCheckSatAndSun) => {
      state.ifCheckSatAndSun = ifCheckSatAndSun;
    },
    SET_CHART_DATA_BY_TIME_FOR_BAR: (state, chartDataByTimeForBar) => {
      state.chartDataByTimeForBar = chartDataByTimeForBar;
    },
    SET_LATER_LIST: (state, laterList) => {
      state.laterList = laterList;
    },
    SET_ABSENTER_LIST: (state, absenterList) => {
      state.absenterList = absenterList;
    },
    SET_CHART_DATA_BY_DATE_FOR_LINE: (state, chartDataByDateForLine) => {
      state.chartDataByDateForLine = chartDataByDateForLine;
    },
    SET_GET_ATTENDANCE_DATA_IS_LOADING: (state, getAttendanceDataIsLoading) => {
      state.getAttendanceDataIsLoading = getAttendanceDataIsLoading;
    },
    SET_SCHOOL_LIST: (state, schoolList) => {
      state.schoolList = schoolList;
    },
    SET_SELECTED_SCHOOL: (state, selectedSchool) => {
      state.selectedSchool = selectedSchool;
    },
    SET_CLOCK_TYPE: (state, clockType) => {
      state.clockType = clockType;
    }
  },

  actions: {
    async setTimeTab({ commit }, timeTab) {
      commit('SET_TIME_TAB', timeTab);
    },

    async setSelectedClass({ commit }, selectedClass) {
      commit('SET_SELECTED_CLASS', selectedClass);
    },

    async setSelClass({ commit }, selectedClass) {
      commit('SET_SEL_CLASS', selectedClass);
    },

    async setStrategyListForTeacher({ commit }, strategyListByTeacher) {
      commit('SET_STRATEGY_LIST_BY_TEACHER', strategyListByTeacher);
    },

    async setSelectedStrategy({ commit }, selectedStrategy) {
      commit('SET_SELECTED_STRATEGY', selectedStrategy);
    },

    async setSatAndSun({ commit }, ifCheckSatAndSun) {
      commit('SET_CHECK_SAT_AND_SUN', ifCheckSatAndSun);
    },

    async setSelectedSchool({ commit }, selectedSchool) {
      commit('SET_SELECTED_SCHOOL', selectedSchool);
    },

    async setSelectedSchoolForLogin({ commit }, data) {
      commit('SET_SELECTED_SCHOOL', data.selectedSchool);
    },

    /* 获取班级列表及对应的作息策略 */
    async getClassListByUserIdAndSchoolId({ state, commit }) {
      try {
        const params = {
          userId: util.cookies.get('uuid'),
          userType: '1',
          status: '1',
          dataSource: 'hitecloud',
          schoolId: state.selectedSchool
        };
        const response = await api.getClassListByUserIdAndSchoolId(params);
        if (response && response.length > 0) {
          commit('SET_CLASS_LIST', response);
          commit('SET_SELECTED_CLASS', `${response[0].class_id}<!!!>${response[0].tech_uid}`);
        } else {
          commit('SET_CLASS_LIST', []);
          commit('SET_SELECTED_CLASS', '');
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /* 获取班级列表及对应的作息策略 */
    async getClassListBySchoolId({ state, commit }, requestParams) {
      try {
        const params = {
          userId: util.cookies.get('uuid'),
          userType: '1',
          status: '1',
          dataSource: 'hitecloud',
          schoolId: state.selectedSchool,
          requestFlag:
            requestParams.requestFlag === '/class' && requestParams.userType === '2' ? '2' : '1'
        };
        const response = await api.getClassListBySchoolId(params);
        if (response && response.length > 0) {
          commit('SET_CLASS_LIST', response);
          commit('SET_SELECTED_CLASS', `${response[0].class_id}<!!!>${response[0].tech_uid}`);
          commit('SET_SEL_CLASS', `${response[0].class_name}`);
        } else {
          commit('SET_CLASS_LIST', []);
          commit('SET_SELECTED_CLASS', '');
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /* 根据班级ID获取作息时间列表 */
    getSchedulesByClassId({ state, commit }) {
      return new Promise((resolve, reject) => {
        const params = {
          classId: state.selectedClass.split('<!!!>')[0],
          dateFlag: state.timeTab === 'today' ? '0' : '1',
          dynamicFlag: state.selectedSchool
        };
        api
          .getSchedulesByClassId(params)
          .then(async response => {
            if (response && response.length > 0) {
              const index = getTimeRangeNow(response);
              commit('SET_STRATEGY_LIST_BY_TEACHER', response);
              // commit(
              //   'SET_SELECTED_STRATEGY',
              //   `${response[0].id}<!!!>${response[0].name}<!!!>${response[0].sectionId}`
              // );
              if (state.timeTab === 'today') {
                commit(
                  'SET_SELECTED_STRATEGY',
                  `${response[index].id}<!!!>${response[index].name}<!!!>${
                    response[index].sectionId
                  }`
                );
              } else {
                commit(
                  'SET_SELECTED_STRATEGY',
                  `${response[0].id}<!!!>${response[0].name}<!!!>${response[0].sectionId}`
                );
              }
            } else {
              commit('SET_STRATEGY_LIST_BY_TEACHER', []);
              commit('SET_SELECTED_STRATEGY', '');
            }
            // this.dispatch('getAttendanceResult');
            // 结束
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    getAttendanceResult({ state, commit }) {
      commit('SET_GET_ATTENDANCE_DATA_IS_LOADING', true);
      return new Promise((resolve, reject) => {
        const params = {
          userId: util.cookies.get('uuid'),
          dynamicFlag: state.selectedSchool,
          classId: state.selectedClass.split('<!!!>')[0],
          scheduleId:
            state.selectedStrategy.indexOf('<!!!>') > -1
              ? state.selectedStrategy.split('<!!!>')[0]
              : '',
          sectionId: state.selectedStrategy !== '' ? state.selectedStrategy.split('<!!!>')[2] : ''
        };
        if (state.timeTab === 'today') {
          params.range = '1';
          params.applyCase = '4';
        } else if (state.timeTab === 'yesterday') {
          params.range = '2';
          params.scheduleName =
            state.selectedStrategy !== '' ? state.selectedStrategy.split('<!!!>')[1] : '';
          params.applyCase = '4';
        } else if (state.timeTab === 'week') {
          params.range = '3';
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '4';
          }
        } else if (state.timeTab === 'month') {
          params.range = '4';
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            params.applyCase = '4';
          }
        }
        api
          .getAttendanceResult(params)
          .then(async response => {
            commit('SET_CLOCK_TYPE', response.clockType);
            if (state.timeTab === 'today' || state.timeTab === 'yesterday') {
              if (
                Number(response.absentCount) === 0 &&
                Number(response.lateCount) === 0 &&
                Number(response.onTimeCount) === 0
              ) {
                commit('SET_CHART_DATA_FOR_PIE', []);
              } else {
                // clockType :0-自动点名，1-班牌
                let chartDataForPie = [];
                if (response.clockType === '0') {
                  chartDataForPie = [
                    {
                      name: `未签到\n${response.absentCount} 人`,
                      value: response.absentCount
                    },
                    {
                      name: `按时签到\n${response.onTimeCount} 人`,
                      value: response.onTimeCount
                    }
                  ];
                } else {
                  chartDataForPie = [
                    {
                      name: `未签到\n${response.absentCount} 人`,
                      value: response.absentCount
                    },
                    {
                      name: `迟到\n${response.lateCount} 人`,
                      value: response.lateCount
                    },
                    {
                      name: `按时签到\n${response.onTimeCount} 人`,
                      value: response.onTimeCount
                    }
                  ];
                }
                commit('SET_CHART_DATA_FOR_PIE', chartDataForPie);
              }

              let chartDataByTimeForBar = [];
              if (response.stageCounts && response.stageCounts.length > 0) {
                for (let i = 0; i < response.stageCounts.length; i += 1) {
                  let dataObj = {
                    name: `${response.stageCounts[i].stage}`,
                    value: `${response.stageCounts[i].clockNum}`
                  };
                  chartDataByTimeForBar.push(dataObj);
                }
                commit('SET_CHART_DATA_BY_TIME_FOR_BAR', chartDataByTimeForBar);
              } else {
                commit('SET_CHART_DATA_BY_TIME_FOR_BAR', []);
              }
            } else if (state.timeTab === 'week' || state.timeTab === 'month') {
              if (response.attendInfo && response.attendInfo.length > 0) {
                commit('SET_CHART_DATA_BY_DATE_FOR_LINE', response.attendInfo);
              } else {
                commit('SET_CHART_DATA_BY_DATE_FOR_LINE', []);
              }
            }
            let laterList = [];
            let absenterList = [];
            if (response.lateStudents && response.lateStudents.length > 0) {
              for (let j = 0; j < response.lateStudents.length; j += 1) {
                let dataObj = {
                  name: `${response.lateStudents[j].name}`,
                  value: `${response.lateStudents[j].count}`,
                  imgUrl: `${response.lateStudents[j].pic_url}`,
                  lateTime: `${response.lateStudents[j].time}`
                };
                laterList.push(dataObj);
              }
              commit('SET_LATER_LIST', laterList);
            } else {
              commit('SET_LATER_LIST', []);
            }
            if (response.absentStudents && response.absentStudents.length > 0) {
              for (let k = 0; k < response.absentStudents.length; k += 1) {
                let dataObj = {
                  name: `${response.absentStudents[k].name}`,
                  value: `${response.absentStudents[k].count}`,
                  imgUrl: `${response.absentStudents[k].pic_url}`
                };
                absenterList.push(dataObj);
              }
              commit('SET_ABSENTER_LIST', absenterList);
            } else {
              commit('SET_ABSENTER_LIST', []);
            }
            // 结束
            resolve();
          })
          .catch(err => {
            reject(err);
          });

        setTimeout(function() {
          commit('SET_GET_ATTENDANCE_DATA_IS_LOADING', false);
        }, 500);
      });
    },

    async exportByDate({ state }, requestParams) {
      try {
        const classId = state.selectedClass.split('<!!!>')[0];
        const range = state.timeTab === 'week' ? '1' : '2';
        let applyCase = '';
        if (state.timeTab === 'today') {
          applyCase = '4';
        } else if (state.timeTab === 'yesterday') {
          applyCase = '4';
        } else if (state.timeTab === 'week') {
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '4';
          }
        } else if (state.timeTab === 'month') {
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '4';
          }
        }
        if (state.timeTab === 'today') {
          window.location.href = `/attendanceApi/export/todayExport?classId=${classId}&dayStr=${
            requestParams.date
          }&dynamicFlag=${state.selectedSchool}`;
        } else {
          window.location.href = `/attendanceApi/export/weekOrMonthExport?classId=${classId}&range=${range}&dynamicFlag=${
            state.selectedSchool
          }&applyCase=${applyCase}`;
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /* 获取班级列表及对应的作息策略 */
    async exportReport({ state }) {
      try {
        const classId = state.selectedClass.split('<!!!>')[0];
        const range = state.timeTab === 'week' ? '1' : '2';
        let applyCase = '';
        if (state.timeTab === 'today') {
          applyCase = '4';
        } else if (state.timeTab === 'yesterday') {
          applyCase = '4';
        } else if (state.timeTab === 'week') {
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '4';
          }
        } else if (state.timeTab === 'month') {
          if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '1';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            !state.ifCheckSatAndSun[1]
          ) {
            applyCase = '2';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            !state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '3';
          } else if (
            state.ifCheckSatAndSun.length === 2 &&
            state.ifCheckSatAndSun[0] &&
            state.ifCheckSatAndSun[1]
          ) {
            applyCase = '4';
          }
        }
        // window.location.href = `http://${
        //   window.location.hostname
        // }:9002/modules/export/teacherExport?classId=${classId}&range=${range}&applyCase=${applyCase}&dynamicFlag=${
        //   state.selectedSchool
        // }`;
        // window.location.href = `/cameraApi/modules/export/teacherExport?classId=${classId}&range=${range}&applyCase=${applyCase}&dynamicFlag=${
        //   state.selectedSchool
        // }`;
        window.location.href = `/attendanceApi/export/teacherExport?classId=${classId}&range=${range}&applyCase=${applyCase}&dynamicFlag=${
          state.selectedSchool
        }`;
      } catch (error) {
        return Promise.reject(error);
      }
    },

    /* 获取学校列表 */
    getSchoolList({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = {
          userId: util.cookies.get('uuid')
        };
        api
          .getSchoolList(params)
          .then(async response => {
            let schoolListArr = [];
            for (let i = 0; i < response.length; i += 1) {
              const schoolObj = {
                name: response[i].name,
                id: response[i].thirdPartyId,
                type: response[i].userType
              };
              schoolListArr.push(schoolObj);
            }
            if (schoolListArr.length > 0) {
              commit('SET_SCHOOL_LIST', schoolListArr);
              if (!state.selectedSchool) {
                commit('SET_SELECTED_SCHOOL', schoolListArr[0].id);
              }
            }

            // 结束
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default teacher;
